import { Center, Stack, Text, Title } from '@mantine/core';
import { IconInbox } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  title?: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
  height?: number | string;
}

export function EmptyState({ title, description, action, icon, height = 240 }: EmptyStateProps) {
  const { t } = useTranslation('common');
  return (
    <Center h={height}>
      <Stack align="center" gap="sm" maw={400}>
        {icon ?? <IconInbox size={48} stroke={1.4} />}
        <Title order={4}>{title ?? t('state.empty')}</Title>
        {description ? (
          <Text c="dimmed" ta="center">
            {description}
          </Text>
        ) : null}
        {action}
      </Stack>
    </Center>
  );
}
